// extracted by mini-css-extract-plugin
export default {"self_intro_section":"SelfIntroductionEdit_self_intro_section__tZe6-","self_textarea":"SelfIntroductionEdit_self_textarea__bcZdb"};